import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  backdrop-filter: blur(4px);
  padding: 1rem;
`;

export const ModalContainer = styled.div<{ $challengeSize: string }>`
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  
  /* Fixed widths based on Opayo challenge window sizes */
  ${props => {
    switch (props.$challengeSize) {
      case 'xs': // 250x400
        return `
          width: 250px;
          height: auto;
        `;
      case 'sm': // 390x400
        return `
          width: 390px;
          height: auto;
        `;
      case 'md': // 500x600
        return `
          width: 500px;
          height: auto;
        `;
      case 'lg': // 600x400
        return `
          width: 600px;
          height: auto;
        `;
      case 'xl': // Full screen
        return `
          width: 90vw;
          max-width: 1200px;
          height: 90vh;
        `;
      default:
        return `
          width: 500px;
          height: auto;
        `;
    }
  }}
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  background-color: #f8f9fa;
`;

export const ModalTitle = styled.h3`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 2rem;
  line-height: 1;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #e0e0e0;
    color: #333;
  }

  &:focus {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }
`;

export const IframeContainer = styled.div<{ $challengeSize: string }>`
  position: relative;
  background-color: #f5f5f5;
  overflow: hidden;
  
  /* Fixed heights based on Opayo challenge window sizes */
  ${props => {
    switch (props.$challengeSize) {
      case 'xs': // 250x400
        return `height: 400px;`;
      case 'sm': // 390x400
        return `height: 400px;`;
      case 'md': // 500x600
        return `height: 600px;`;
      case 'lg': // 600x400
        return `height: 400px;`;
      case 'xl': // Full screen
        return `
          flex: 1;
          min-height: 0;
        `;
      default:
        return `height: 600px;`;
    }
  }}
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
    display: block;
  }
`;

export const ModalFooter = styled.div`
  padding: 1rem 1.5rem;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  text-align: center;
`;

export const InfoText = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #666;
  line-height: 1.5;
`;